import React from 'react';
import {
    Modal, ModalHeader, ModalBody, Form, FormGroup, Label,
    Input, Button, Row, Col
} from 'reactstrap';
import InputMask from 'react-input-mask';
import { EditResponsavelType } from '../../context/hooks/useResponsavel';

interface Props {
    isOpen: boolean;
    toggle: () => void;
    responsavel: EditResponsavelType | null;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

export const EditResponsavelModal: React.FC<Props> = ({
    isOpen,
    toggle,
    responsavel,
    onChange,
    onSubmit
}) => {
    if (!responsavel) return null;

    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop="static" size="lg">
            <ModalHeader toggle={toggle}>Alterar informações do responsável</ModalHeader>
            <ModalBody>
                <Form onSubmit={onSubmit}>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="name">Nome</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="text"
                                    name="name"
                                    id="name"
                                    value={responsavel.name}
                                    placeholder="Nome completo"
                                    onChange={onChange}
                                    required
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="email">Email</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="email"
                                    name="email"
                                    id="email"
                                    value={responsavel.email}
                                    placeholder="Email"
                                    onChange={onChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="CPF">CPF</Label>
                                <InputMask
                                    className="form-control form-control-alternative"
                                    mask="999.999.999-99"
                                    type="text"
                                    name="CPF"
                                    id="CPF"
                                    value={responsavel.CPF}
                                    placeholder="000.000.000-00"
                                    onChange={onChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="telephone">Telefone</Label>
                                <InputMask
                                    className="form-control form-control-alternative"
                                    mask="(99) 99999-9999"
                                    type="text"
                                    name="telephone"
                                    id="telephone"
                                    value={responsavel.telephone}
                                    placeholder="(00) 00000-0000"
                                    onChange={onChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="position">Cargo</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="text"
                                    name="position"
                                    id="position"
                                    value={responsavel.position}
                                    placeholder="Cargo do responsável"
                                    onChange={onChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="bank">Banco</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="text"
                                    name="bank"
                                    id="bank"
                                    value={responsavel.bank}
                                    placeholder="Nome do banco"
                                    onChange={onChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="agency">Agência</Label>
                                <InputMask
                                    className="form-control form-control-alternative"
                                    mask="9999"
                                    type="text"
                                    name="agency"
                                    id="agency"
                                    value={responsavel.agency}
                                    placeholder="0000"
                                    onChange={onChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="currentAccount">Conta</Label>
                                <InputMask
                                    className="form-control form-control-alternative"
                                    mask="999999-9"
                                    type="text"
                                    name="currentAccount"
                                    id="currentAccount"
                                    value={responsavel.currentAccount}
                                    placeholder="000000-0"
                                    onChange={onChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="pix">Chave Pix</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="text"
                                    name="pix"
                                    id="pix"
                                    value={responsavel.pix}
                                    placeholder="Chave Pix"
                                    onChange={onChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="observation">Observação</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="textarea"
                                    name="observation"
                                    id="observation"
                                    value={responsavel.observation}
                                    placeholder="Observação"
                                    onChange={onChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <div className="d-flex justify-content-end mt-4">
                        <Button style={{ color: "#FFF", backgroundColor: "#585858" }} type="submit">Salvar alterações</Button>
                        <Button style={{ color: "#FFF", backgroundColor: "#d9534f" }} className="ml-2" onClick={toggle}>Cancelar</Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    );
};

export default EditResponsavelModal;